import HPPConfig from "@/views/configs/hpp/index.vue";

export default [
  {
    path: "hpp",
    name: "H.P.P",
    component: HPPConfig,
  },
];
